import { useState, useEffect } from "react";
import { FaPenToSquare, FaXmark } from "react-icons/fa6";
import { SelectPppoeUser } from "../../../components/forms/selects/SelectPppoeUser";
import { SelectUser } from "../../../components/forms/selects/SelectUser";
import { TicketService } from "../../../services/TicketService"; // Pastikan service update ada
import { ModalWraper } from "../../../components/modal/wraper";
import { TextAreaDefault } from "../../../components/forms/TextAreaDefault";

export const TicketUpdate = ({ open, setOpen, refreshData, initialData }) => {
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        pppoe_user_id: "",
        title: "",
        description: "",
        note: "",
        schedule: "",
        teknisi: [],
    });

    // Efek untuk mengisi form ketika initialData berubah atau modal dibuka
    useEffect(() => {
        if (initialData) {
            // Format schedule untuk datetime-local (YYYY-MM-DDTHH:mm)
            const formattedSchedule = initialData.schedule?.start_time
                ? initialData.schedule.start_time.slice(0, 16).replace(" ", "T")
                : "";

            setFormData({
                pppoe_user_id: initialData.pppoe_user || "", // Harus object sesuai SelectPppoeUser
                title: initialData.title || "",
                description: initialData.description || "",
                note: initialData.note || "",
                schedule: formattedSchedule,
                // Pastikan teknisi di-load sebagai array object
                teknisi: initialData.teknisi || [],
            });
        }
    }, [initialData, open]);

    const closeModal = () => {
        setOpen(false);
        // Jangan reset formData di sini agar tidak kedip saat menutup,
        // tapi idealnya reset saat component unmount jika perlu.
        setLoading(false);
    };

    const handleRemoveTeknisi = (id) => {
        setFormData((prev) => ({
            ...prev,
            teknisi: prev.teknisi.filter((t) => t.id !== id),
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.pppoe_user_id) {
            alert("Silakan pilih pelanggan terlebih dahulu.");
            return;
        }

        try {
            setLoading(true);

            // Format data sebelum kirim ke backend
            const formattedData = {
                pppoe_user_id: formData.pppoe_user_id?.id || formData.pppoe_user_id || "",
                title: formData.title,
                description: formData.description,
                note: formData.note || null,
                schedule: formData.schedule
                    ? formData.schedule.replace("T", " ") + ":00"
                    : null, // Handle jika schedule dihapus

                teknisi: Array.isArray(formData.teknisi) && formData.teknisi.length > 0
                    ? formData.teknisi.map((t) => t.id || t).filter(Boolean)
                    : [],
            };

            // Panggil Service Update (pastikan method ini ada di TicketService)
            await TicketService.update({
                id: initialData.id, 
                data: formattedData
            });

            if (refreshData) refreshData();
            closeModal();
        } catch (error) {
            console.error("Gagal mengupdate tiket:", error);
            alert("Gagal mengupdate tiket. Cek console untuk detail.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <ModalWraper
            isOpen={open}
            setIsOpen={setOpen}
            title="Edit Tiket"
            maxWidth={"md:max-w-[1000px]"}
            icon={<FaPenToSquare className="text-cyan-500" />}
        >
            <form onSubmit={handleSubmit} className="space-y-5">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="grid gap-3">
                        {/* Pilih Pelanggan */}
                        <SelectPppoeUser
                            label="Pelanggan"
                            value={formData.pppoe_user_id}
                            onChange={(value) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    pppoe_user_id: value,
                                }))
                            }
                        />

                        {/* Jenis Gangguan & Jadwal */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label className="block text-xs font-semibold text-slate-400 mb-2 uppercase tracking-wider">
                                    Jenis Gangguan
                                </label>
                                <select
                                    required
                                    className="w-full px-4 py-3 text-sm rounded-xl bg-slate-800/60 border border-slate-700 text-slate-100 focus:outline-none focus:border-indigo-500 transition-colors"
                                    value={formData.title}
                                    onChange={(e) =>
                                        setFormData((prev) => ({
                                            ...prev,
                                            title: e.target.value,
                                        }))
                                    }
                                >
                                    <option value="">- Pilih Gangguan -</option>
                                    <option value="Loss Merah">Loss Merah</option>
                                    <option value="Redaman Tinggi">Redaman Tinggi</option>
                                    <option value="SSID Hilang">SSID Hilang</option>
                                    <option value="SSID Lemah">SSID Lemah</option>
                                    <option value="ONT Mati">ONT Mati</option>
                                    <option value="PON Blinking">PON Blinking</option>
                                    <option value="Internet Offline">Internet Offline</option>
                                    <option value="Internet Lemot">Internet Lemot</option>
                                    <option value="Lainnya">Lainnya</option>
                                </select>
                            </div>

                            <div>
                                <label className="block text-xs font-semibold text-slate-400 mb-2 uppercase tracking-wider">
                                    Jadwal Kunjungan
                                </label>
                                <input
                                    type="datetime-local"
                                    className="w-full px-4 py-3 text-sm rounded-xl bg-slate-800/60 border border-slate-700 text-slate-100 focus:outline-none focus:border-indigo-500 transition-colors"
                                    value={formData.schedule}
                                    onChange={(e) =>
                                        setFormData((prev) => ({
                                            ...prev,
                                            schedule: e.target.value,
                                        }))
                                    }
                                />
                            </div>
                        </div>

                        {/* Pilih Teknisi */}
                        <div>
                            <label className="block text-xs font-semibold text-slate-400 mb-2 uppercase tracking-wider">
                                Pilih Teknisi
                            </label>
                            <SelectUser
                                value={null} // Reset value select setelah pilih
                                onChange={(selectedUser) => {
                                    if (selectedUser) {
                                        setFormData((prev) => {
                                            const isExist = prev.teknisi.some((t) => t.id === selectedUser.id);
                                            if (isExist) return prev;
                                            return {
                                                ...prev,
                                                teknisi: [...prev.teknisi, selectedUser],
                                            };
                                        });
                                    }
                                }}
                                placeholder="Cari dan tambah teknisi..."
                            />

                            {formData.teknisi.length > 0 && (
                                <div className="flex flex-wrap gap-2 mt-3">
                                    {formData.teknisi.map((tech) => (
                                        <div
                                            key={tech.id}
                                            className="flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs font-medium transition-colors"
                                            style={{
                                                background: "rgba(99, 102, 241, 0.15)",
                                                border: "1px solid rgba(99, 102, 241, 0.3)",
                                                color: "#a5b4fc",
                                            }}
                                        >
                                            <span>{tech.name}</span>
                                            <button
                                                type="button"
                                                onClick={() => handleRemoveTeknisi(tech.id)}
                                                className="hover:text-white transition-colors"
                                            >
                                                <FaXmark className="text-[10px]" />
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="grid gap-3">
                        <TextAreaDefault
                            id="description"
                            label="Keterangan / Masalah"
                            placeholder="Detail keluhan pelanggan..."
                            value={formData.description}
                            onChange={(e) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    description: e.target.value,
                                }))
                            }
                        />
                        <TextAreaDefault
                            id="note"
                            label="Catatan Tambahan"
                            SubLabel="(opsional)"
                            placeholder="Catatan internal..."
                            value={formData.note}
                            onChange={(e) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    note: e.target.value,
                                }))
                            }
                        />
                    </div>
                </div>

                <div className="flex gap-3 pt-2">
                    <button
                        type="button"
                        onClick={closeModal}
                        disabled={loading}
                        className="flex-1 py-3 rounded-xl border border-slate-700 text-slate-300 transition-colors hover:bg-slate-800 disabled:opacity-50"
                    >
                        Batal
                    </button>
                    <button
                        type="submit"
                        disabled={loading}
                        className="flex-1 py-3 rounded-xl bg-cyan-600 hover:bg-cyan-500 disabled:bg-slate-700 text-white font-semibold flex items-center justify-center gap-2 transition-colors"
                    >
                        {loading ? "Sedang Mengupdate..." : "Update Tiket"}
                    </button>
                </div>
            </form>
        </ModalWraper>
    );
};